"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Output;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ansiToReact = require("ansi-to-react");

var _ansiToReact2 = _interopRequireDefault(_ansiToReact);

var _transforms = require("@nteract/transforms");

var _richestMime = require("./richest-mime");

var _richestMime2 = _interopRequireDefault(_richestMime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var classPrefix = "nteract-display-area-";

function Output(props) {
  var output = props.output;
  var outputType = output.output_type;
  switch (outputType) {
    case "execute_result":
    // We can defer to display data here, the cell number will be handled
    // separately. For reference, it is output.execution_count
    // The execution_count belongs in the component above if
    // this is a code cell

    // falls through
    case "display_data":
      {
        var bundle = output.data;
        var metadata = output.metadata;
        return _react2.default.createElement(_richestMime2.default, {
          expanded: props.expanded,
          bundle: bundle,
          metadata: metadata,
          displayOrder: props.displayOrder,
          transforms: props.transforms,
          theme: props.theme,
          models: props.models
        });
      }
    case "stream":
      {
        var text = output.text;
        var name = output.name;
        switch (name) {
          case "stdout":
          case "stderr":
            return _react2.default.createElement(
              _ansiToReact2.default,
              { className: classPrefix + name },
              text
            );
          default:
            return null;
        }
      }
    case "error":
      {
        var traceback = output.traceback;
        if (!traceback) {
          return _react2.default.createElement(
            _ansiToReact2.default,
            { className: classPrefix + "traceback" },
            output.ename + ": " + output.evalue
          );
        }
        return _react2.default.createElement(
          _ansiToReact2.default,
          { className: classPrefix + "traceback" },
          traceback.join("\n")
        );
      }
    default:
      return null;
  }
}

Output.defaultProps = {
  transforms: _transforms.transforms,
  displayOrder: _transforms.displayOrder
};
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(classPrefix, "classPrefix", "src/output.js");
  reactHotLoader.register(Output, "Output", "src/output.js");
  leaveModule(module);
})();

;


//////////////////
// WEBPACK FOOTER
// ./~/@nteract/display-area/lib/output.js
// module id = 121
// module chunks = 186292428941015